export default function HelpPage() {
	return (
		<>
			<section id="faqs">
				<h2>Frequently Asked Questions (FAQs)</h2>
				<article>
					<h3>How do I link my bank account?</h3>
					<p>
						To link your bank account, go to the 'Accounts' tab and select 'Add Account'. Follow the prompts to securely
						connect your bank.
					</p>
				</article>
				<article>
					<h3>How to set a monthly budget?</h3>
					<p>
						Under the 'Budgets' section, click 'Create New Budget', choose categories and set your spending limits for
						each.
					</p>
				</article>
			</section>

			<section id="user-guides">
				<h2>User Guides</h2>
				<article>
					<h3>Getting Started with BudgetApp</h3>
					<p>This guide walks you through the initial setup process and basic features of BudgetApp.</p>
				</article>
				<article>
					<h3>Advanced Budgeting Techniques</h3>
					<p>Learn how to utilize BudgetApp for comprehensive financial planning and tracking.</p>
				</article>
			</section>

			<section id="technical-support">
				<h2>Technical Support</h2>
				<p>
					Having issues with BudgetApp? Contact our support team at{' '}
					<a href="mailto:support@elkmoney.com">support@elkmoney.com</a>.
				</p>
			</section>

			<section id="community-forum">
				<h2>Community Forum</h2>
				<p>
					Join discussions, share tips, and get insights from other BudgetApp users in our{' '}
					<a href="/">Community Forum</a>.
				</p>
			</section>

			<section id="troubleshooting">
				<h2>Troubleshooting Tips</h2>
				<article>
					<h3>Resolving Sync Issues</h3>
					<p>Find steps to troubleshoot and resolve common synchronization problems with your linked accounts.</p>
				</article>
			</section>
		</>
	);
}
